<template>
<!-- <div id="sticky-nav" class="wrapper" > -->

  <a name="Conjunc">
<div class="wrapper-nav-sp">
  <!-- <div class="count-down-num" > -->
    <div :class="navClass" :style="`height:${navH}px`" >
  </div>
  </div>
  </a>
</template>

<script>

import NativeMsg from '@/base/NativeMsg';
import StoreManger from '@/utils/FundHQJHManger';

export default {
  data() {
    return {
      showType: 0,
      navH: 88,
      navClass: 'nav-white',
    };
  },
  created() {
    NativeMsg.reg('refreshBarbtnSp', (res) => {
      this.showTopViewType(res.type);
    });
    this.configureLayout();
  },
  methods: {
    // 高度适配
    configureLayout() {
      this.navH = StoreManger.getNAVSTATEHEIGHT() + 12;
      // #if EXECUTION_ENV == 'web'
      this.navH = 12;
      // #endif
    },
    showTopViewType(type) {
      console.log(`showTopViewType${type}`);
      // 默认0 白色 1涨 2跌 3平
      if (type === 1) {
        this.showType = 1;
        this.navClass = 'nav-red';
      }
      if (type === 2) {
        this.showType = 2;
        this.navClass = 'nav-green';
      }
      if (type === 3) {
        this.showType = 3;
        this.navClass = 'nav-grey';
      }
      if (type === 0) {
        this.showType = 0;
        this.navClass = 'nav-white';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper-nav-sp {
  width: 100%;
  align-items: center;
}
.nav-white {
  opacity: 0.1;
  background-color: #E93801;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 176px;
  opacity: 0;
}
.nav-red {
  opacity: 0.1;
  background-color: #E93801;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 176px;
  opacity: 0;
}
.nav-green {
  opacity: 0.1;
  background-color: #E93801;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 176px;
}
.nav-grey {
  opacity: 0.1;
  background-color: #e3e3e3;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 176px;
  opacity: 0;
}
.bottom-line{
  margin-left: 25px;
  margin-right: 25px;
}
</style>
